import gql from 'graphql-tag'

export const SH_BLOCKER_GET_BLOCKING_USERS_BY_EMAIL = gql`
  mutation GetBlockingUsersByEmail($email: String!) {
    getBlockingUsersByEmail(email: $email) {
      id
      status
      type
      email
      fein
      ssn
      voidCheckURL
      creditCheckURL
      driverLicenseFrontURL
      requiredFilesUploadedAt
      finishedAt
      isRequireAssignment
      isRequireCreditCheck
      isRequireVoidCheck
      isRequireDriverLicense
      isRequireFEIN
      isRequireSSN
      signNowDocument {
        documentId
        embeddedInviteId
        signedAt
      }
    }
  }
`

export const SH_BLOCKER_FINISH_BLOCKING_USER_SIGN_NOW_LINK = gql`
  mutation FinishBlockingUserSignNowLink($documentId: String!) {
    finishBlockingUserSignNowLink(documentId: $documentId) {
      code
      success
      message
    }
  }
`

export const SH_BLOCKER_GET_S3_UPLOAD_FILE_PRESIGNED_URL = gql`
  mutation GetS3UploadFilePreSignedUrl($filePaths: [String!]!, $bucketName: String) {
    getS3UploadFilePreSignedUrl(filePaths: $filePaths, bucketName: $bucketName) {
      items {
        preSignedUrl
        filePath
      }
    }
  }
`

export const SH_BLOCKER_FINISH_UPLOAD_REQUIRED_FILES = gql`
  mutation FinishUploadRequiredFiles(
    $id: String!
    $voidCheckURL: String!
    $driverLicenseFrontURL: String!
  ) {
    finishUploadRequiredFiles(
      id: $id
      voidCheckURL: $voidCheckURL
      driverLicenseFrontURL: $driverLicenseFrontURL
    ) {
      code
      success
      message
    }
  }
`

export const SH_BLOCKER_UPDATE_USER_BLOCK = gql`
  mutation UpdateUserBlock(
    $email: String!
    $creditCheckURL: String
    $fein: String
    $ssn: String
  ) {
    updateUserBlock(
      email: $email
      creditCheckURL: $creditCheckURL
      fein: $fein
      ssn: $ssn
    ) {
      code
      success
      message
    }
  }
`
